import React from "react";

export const Content = ({ children, className }) => {
  return (
    <section className={`layout__container ${className ?? ""}`}>
      {children}
    </section>
  );
};
